import { createContext } from "react";
import { SuccessfulUpdateType } from "../helpers/types";

const Context = createContext<SuccessfulUpdateType>({
  onSuccessfulUpdate: () => {},
});

export default Context;
